<template>
  <div>
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- 委托信息模块start -->
        <div class="Item_list">
          <div class="weituo">
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">{{$t('i18n_Order_info')}}</p>
          </div>
          <el-form label-position="right" label-width="106px" size="small" :rules="entrustInfoRules" ref="entrustForm" :model="entrustInfo">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_person')">
                  <el-input
                    disabled
                    v-model="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_number')">
                  <el-input
                    disabled
                    v-model="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_entrusting_company')">
                  <el-input disabled v-model="Authorization.namec"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 51px">
                <el-form-item :label="$t('i18n_pay_party')" prop="payType">
                  <el-radio-group
                    v-model="entrustInfo.payType"
                    style="width: 100%"
                  >
                    <el-radio label="PP">{{$t('i18n_domestic_payment')}}</el-radio>
                    <el-radio label="CC">{{$t('i18n_foreign_payment')}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <!--<el-col :span="12">
                <el-form-item :label="$t('i18n_estimated_receiving_time')" prop="inWarehouseTime">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :placeholder="addPls('i18n_estimated_receiving_time', 'select')"
                    v-model="entrustInfo.inWarehouseTime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>-->
              <el-col :span="12">
                <el-form-item :label="$t('i18n_logistics_services')">
                  <el-input
                    disabled
                    v-model="productName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_remark')">
                  <el-input v-model="entrustInfo.remarks"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
              <!-- <el-col :span="12">
                <el-form-item label="清关方式" prop="customsClearanceType">
                  <el-select
                    placeholder="请选择"
                    v-model="entrustInfo.customsClearanceType"
                    style="width: 100%"
                  >
                    <el-option label="自清" value="Z"></el-option>
                    <el-option label="亦邦双清" value="S"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
          </el-form>
        </div>
        <!-- 委托信息模块end -->
        <!-- 地址信息模块start -->
        <div class="Item_list">
          <addressInfo
            :sendFeeForAir="sendFeeForAir"
            :getGoodsDTO="getGoodsDTO"
            :recGoodsDTO="recGoodsDTO"
            :delGoodsDTO="delGoodsDTO"
            :toDoorForm="toDoorForm"
            :cangkuitem="cangkuitem"
            @changeTi="changeTi"
            @rowClick="getTimoney"
            ref="address"
          ></addressInfo>
        </div>
        <!-- 地址信息模块end -->
        <!-- 商品信息模块start -->
        <div class="Item_list">
          <goodsInfo
            :goodsInfoForm="goodsInfoForm"
            :goodsTypeOptions="goodsTypeOptions"
            @change="goodsInfoChange"
            @goodTypechange="goodTypechange"
            @del="delGoods"
            @edit="delGoods"
          ></goodsInfo>
        </div>
        <!-- 商品信息模块end -->
        <!-- 贸易信息模块start -->
        <div class="Item_list">
          <div class="weituo">
            <i class="el-icon-s-order" style="color: #63b947; font-size: 25px"></i>
            <p class="tittype">{{$t('i18n_trade_information')}}</p>
            <div class="addMore">
              <el-button icon="el-icon-upload" size="medium" type="text" @click="upload">{{$t('i18n_upload_clearance_documents')}}</el-button>
            </div>
          </div>
          <el-form size="small" label-position="right" label-width="106px" :model="tradeInfoForm" :rules="tradeInfoFormRules" ref="tradeForm">
            <el-form-item label-width="0">
              <el-checkbox-group v-model="declareType" @change="tradeInfoChange">
                <el-checkbox label="M" name="type" checked>{{$t('i18n_customs_declaration_with_Agent_license')}}</el-checkbox>
                <el-checkbox label="T" name="type">{{$t('i18n_customs_declaration_with_tax_refund')}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!--
            <div v-if="tradeInfoForm.declareType[0] === 'T'">
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-form-item label="退税联系电话" prop="declareTelephone">
                    <el-input v-model="tradeInfoForm.declareTelephone" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系人" prop="declareContacts">
                    <el-input v-model="tradeInfoForm.declareContacts" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="省市区" prop="TSAddres">
                    <el-cascader
                      style="width: 100%"
                      ref="refSsqname"
                      placeholder=""
                      :options="jackCitylist"
                      v-model="tradeInfoForm.TSAddres"
                      :props="defaultParams2"
                      @change="changeTSssq"
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="详细地址" prop="declareAddress">
                    <el-input v-model="tradeInfoForm.declareAddress" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            -->
            <div class="Item_list" v-if="tradeInfoForm.declareType[0] === 'T'">
               <addressInfoDeclarer
                  :declarerDTO="declarerDTO"
               ></addressInfoDeclarer>
            </div>
          </el-form>
          <el-upload
            class="upload-demo"
            ref="upload"
            action="https://www.yundaomen.com.cn:8080/busKY/uploadAirJobsBGInfo"
            :headers="{
              token: Authorization.token
            }"
            :limit="1"
            :http-request="fileUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
          >
          </el-upload>
        </div>
        <!-- 贸易信息模块end -->
        <!-- 备注模块start -->
        <div class="Item_list">
          <div class="weituo">
            <i class="el-icon-paperclip" style="color: #63b947; font-size: 25px"></i>
            <p class="tittype">{{$t('i18n_remark')}}</p>
          </div>
          <el-form label-width="80px" size="small">
            <el-form-item :label="$t('i18n_delivery_remark')">
              <el-input v-model="delGoodsDTO.delGoodsRemarks"></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_pickup_remark')">
              <el-input v-model="getGoodsDTO.getGoodsRemarks"></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$t('i18n_Clients_tracking_number')">
              <el-input v-model="customerNo"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <!-- 备注模块end -->
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <div>
          <p
            style="
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #343434;
            "
          >
            {{$t('i18n_cost_calculation')}}
          </p>
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">{{$t('i18n_ocean_freight_cost')}}</p>
            <p
              class="coutText"
              v-for="(item, index) in HYFmoney.goodsTypeFeeDTOS"
              :key="index"
            >
              <span class="littit">{{ item.goodsTypeName }}</span>
              <span class="fontString">{{ item.currency }} {{ item.amount }}</span>
              <span style="margin-left:10px">({{item.calDesc}})</span>
            </p>
            <p class="coutText">
              <span class="littit">{{$t('i18n_subtotal')}}</span>
              <span class="fontString"
                >{{ HYFmoney.currency }}{{ HYFmoney.amount }}</span
              >
            </p>
          </div>
          <transition enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRight">
            <div
              class="Item_Right animate__animated animate__bounceInRight"
              v-show="toDoorForm.isGetGoodsToDoor"
            >
              <p class="tit">{{$t('i18n_pickup_fee')}} <span v-if="tuoCheData.minKilometer" style="font-size:13px;float: right;font-weight: 500;">({{tuoCheData.minKilometer+'KM'}}--{{tuoCheData.maxKilometer+'KM'}})</span> </p>
              <p class="coutText">
                <span class="littit">{{$t('i18n_pickup_at_original_port')}}</span>
                <span class="fontString"
                  >{{ tuoCheData.currency }} {{ tuoCheData.amount }}</span
                >
              </p>
            </div>
          </transition>
          <div class="Item_Right">
            <p class="coutText" style="display: flex; justify-content: space-between; margin-top: 0">
              <span class="littit">{{$t('i18n_total_cost')}}</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span
                  ><span class="fontString" v-show="item.currency != ''">{{
                    item.currency
                  }}</span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                    >{{ item.amount }}</span
                  ></span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">{{$t('i18n_Covert_to_CNY')}}</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
        </div>
        <div style="width: 100%;">
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #5ab53c; color: #ffffff"
              @click="entrust"
              >{{$t('i18n_submit_order')}}</el-button
            >
          </div>
        </div>
      </div>

      <el-dialog
      :title="$t('i18n_Are_your_confirm_order')"
      center
      :visible.sync="dialogTableVisible"
      width="520px"
      >
        <div class="showDalog">
          <div class="header_text">
            <div class="count_center" style="margin-right: 50px">
              <span class="cangkutit" style="color: red">
                {{cangkuitem.namec}}
              </span>
              <span class="ckttext" style="margin-top: 10px">入仓仓库</span>
            </div>
            <div class="cangkutit" style="margin-right: 50px">
              <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
              <img style="height:32px;" src="../../assets/airOrder.png" alt="" />
            </div>
            <div class="count_center">
              <span class="cangkutit" style="color: red">
                {{ PScangkuitem.namec }}
              </span>
              <span class="ckttext" style="margin-top: 10px">{{$t('i18n_destination_city')}}</span>
            </div>
          </div>
          <div
            class="goodlist"
            style="
              margin-top: 40px;
              width: 100%;
              float: left;
              padding: 0px 40px;
              box-sizing: border-box;
              margin-bottom: 30px;
            "
          >
            <p style="color: #999999">{{$t('i18n_estimated_cost')}}</p>
            <div style="padding: 5px">
              <p style="font-weight: bold; color: #333333">
                CNY {{ calculatePrice }}
              </p>
            </div>
          </div>
          <div class="Qdbtn LR_center" style="margin-top: 30px">
            <div
              @click="dialogTableVisible = false"
              class="btnstyle"
              style="
                height: 35px;
                background: #ffffff;
                border: 2px solid #dcdcdc;
                border-radius: 35px;
              "
            >
              {{$t('i18n_cancel')}}
            </div>
            <div
              @click="submitOrder"
              class="btnstyle"
              style="
                border: 1px solid #5ab53c;
                font-size: 30rpx;
                background: #ff3939;
                border-color: #ff3939;
                color: #ffffff;
              "
            >
              {{$t('i18n_confirm_order')}}
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="successDialogVisi"
        width="650px"
        :modal="true"
        :close-on-click-modal="false"
      >
        <div class="count_center">
          <div class="centerCoutn">
            <div style="width: 100%; text-align: center;">
              <i
                style="font-size: 55px; color: #00c300"
                class="el-icon-success animate__animated animate__bounceInDown"
              ></i>
              <p
                style="
                  font-size: 20px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-top: 27px;
                "
              >
                {{$t('i18n_order_completed')}}
              </p>
              <p
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #999999;
                  margin-top: 8px;
                "
              >
                {{$t('i18n_waiting_shipment_to_warehoused')}}
              </p>
              <div class="countText">
                <p>{{$t('i18n_warehouse_number')}}：{{ orderInfo.innos }}</p>
                <p>
                  {{$t('i18n_receiver')}}：<span>{{ sendFeeForAir.name }}</span>
                  <span style="margin-left: 10px">{{ sendFeeForAir.tel }}</span>
                </p>
                <p>
                  {{$t('i18n_consignee_address')}}：{{ sendFeeForAir.country }}{{ sendFeeForAir.city
                  }}{{ sendFeeForAir.address }}
                </p>
              </div>
            </div>
            <div class="btnWrap" style="width: 100%; margin-top: 44px">
              <div class="LR_center" style="width: 628px">
                <div class="btn1" @click="pathBilltab()">{{$t('i18n_track_order')}}</div>
                <div class="btn2" @click="nextSetbill()">{{$t('i18n_continue_to_order')}}</div>
                <div class="btn2" @click="labelDownload()">{{$t('i18n_download_labels')}}</div>
                <!-- <div class="btn2" @click="downLoadBill()">入仓单下载</div> -->
              </div>
              <!-- <el-button @click="downLoadBill()" style="margin-left:10px"
              type="success" size="mini">下载入仓单</el-button> -->
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 商品列表 -->
      <el-dialog title="商品列表" width="850px" :visible.sync="goodsTypeShow" :close-on-click-modal="false">
        <div class="typeHeader LR_center">
          <div>
            <el-input
              style="width: 314px"
              placeholder="请输入中文品名"
              v-model="page.name"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                type="primary"
                @click="GetgoodsType"
              >搜索</el-button>
            </el-input>
          </div>
          <div>
            <el-select
              clearable
              @change="GetgoodsType"
              v-model="page.goodstypeid"
              style="width: 100%"
              ref="changeFBAgoodtype"
              placeholder="请选择">
                <el-option v-for="res in goodstypelist" :key="res.id" :label="res.namec" :value="res.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="countTable" style="margin-top: 30px">
          <el-table
            ref="multipleTable"
            border
            :data="tabbar"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="中文名称" align="center" width="120">
              <template slot-scope="scope">{{ scope.row.namec }}</template>
            </el-table-column>
            <el-table-column
              prop="namee"
              label="英文品名"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column prop="materialc" align="center" label="中文材质">
            </el-table-column>
            <el-table-column prop="isHasBattery" align="center" label="是否带电">
              <template slot-scope="scope">{{scope.row.isHasBattery? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column prop="isPowderLiquid" align="center" label="是否液体粉末">
              <template slot-scope="scope">{{scope.row.isPowderLiquid? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column prop="goodstype" align="price" label="商品类型">
            </el-table-column>
          </el-table>
          <div style="width: 100%;
            margin-top:20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;"
          >
            <el-pagination background  @current-change="handleCurrentChange" layout="total,prev, pager, next" :page-size="20" :total="goodslisttotal"></el-pagination>
          </div>
        </div>
        <div slot="footer" style="width: 100%; margin-top:20px">
          <el-button type="primary" @click="changeGoodstype">确认选择</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import addressInfo from '@/components/airOrder/component/addressInfo.vue'
import goodsInfo from './component/goodsInfo.vue'
import addressInfoDeclarer from '../airOrder/component/addressInfoDeclarer.vue'
import { addPls } from '@/utils/placeholderI18n'
export default {
  components: {
    addressInfo,
    goodsInfo,
    addressInfoDeclarer
  },
  data() {
    return {
      Authorization: {
        ...JSON.parse(sessionStorage.getItem("Authorization"))
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      entrustInfo: { // 委托信息
        payType: '',
        inWarehouseId: '',
        inWarehouseTime: '',
        innos: '',
        toWarehouseId: '',
        orderType: 1,
        customsClearanceType: '',
        // refno: '',
        remarks: ''
      },
      entrustInfoRules: {
        payType: [{ required: true, message: this.addPls('i18n_pay_party', 'select'), trigger: 'change' }],
        inWarehouseTime: [{ required: true, message: this.addPls('i18n_warehouse_received_time', 'select'), trigger: 'change' }],
        customsClearanceType: [{ required: true, message: this.addPls('i18n_clearance_metods', 'select'), trigger: 'change' }],
        refno: [{ required: true, message: this.addPls('i18n_Reference', 'input'), trigger: 'blur' }]
      },
      auto_fixed: false,
      allMoreFeeInfo: {
        amount: 0,
        totalExpense: "0",
        feeItemDTOS: [],
      },
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      sendFeeForAir: {
        checked: false,
        name: "",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      feeList:[],
      radio: '上门取件',
      // 商品信息模块数据 start
      addGoodsForm: {
        GoodsList: [
          {
            goodsname: '',
            h: '',
            l: '',
            w: '',
            boxNum: '',
            weight: '',
            cbm: '',
            isBrand: false,
            isHasBattery: false,
            isPowderLiquid: false,
            goodstype: '',
            goodsTypeId: '',
            piece: ''
          }
        ]
      },
      goodsInfoForm: {
        GoodsList: []
      },
      goodsTypeShow: false,
      tabbar: [],
      goodsListIndex: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
        goodstypeid: '',
        name: ''
      },
      goodslisttotal: 0,
      selectGoodslist: [],
      goodstypelist: [],
      goodsTypeOptions: [],
      // 商品信息模块数据 end
      defaultParams2: {
        value: "namec",
        label: "namec"
      },
      declareType: [],
      tradeInfoForm: {
        declareType: ['M'],
        declareTelephone: '',
        declareContacts: '',
        declareAddress: '',
        declareProvince: '',
        declareCity: '',
        declareArea: '',
        TSAddres: []
      },
      tradeInfoFormRules: {
        declareTelephone: [{ required: true, message: '退税联系电话不能为空', trigger: 'blur' }],
        declareContacts: [{ required: true, message: '退税联系人不能为空', trigger: 'blur' }],
        TSAddres: [{ required: true, message: '退税省市区不能为空', trigger: 'change' }],
        declareAddress: [{ required: true, message: '退税详细地址不能为空', trigger: 'blur' }]
      },
      dialogTableVisible: false,
      // 地址信息模块数据 start
      recGoodsDTO: { // 派送地址也就是收货信息
        recGoodsAddress: '',
        recGoodsArea: '',
        recGoodsCity: '',
        recGoodsCountry: '',
        recGoodsName: '',
        recGoodsTel: '',
        recGoodsRemarks: '',
        recGoodsId: ''
      },
      delGoodsDTO: { // 发货信息
        delGoodsId: '',
        delGoodsName: '',
        delGoodsRemarks: '',
        delGoodsTel: ''
      },
      declarerDTO: { // 退税报关
        declarerId: '',
        declarerName: '',
        declarerRemarks: '',
        declarerTel: ''
      },
      toDoorForm: {
        isGetGoodsToDoor: false,
        isSendGoodsToDoor: true,
        toDoorDate: ''
      },
      getGoodsDTO: { // 提货地址
        getGoodsAddress: '',
        getGoodsArea: '',
        getGoodsCity: '',
        getGoodsId: '',
        getGoodsName: '',
        getGoodsProvince: '',
        getGoodsTel: '',
        getGoodsRemarks: '',
        toDoorDate: ''
      },
      // 地址信息模块数据 end
      // 运费
      // finaArapAirBeforeAFFDTO: { // 空运费
      //   amount: 0,
      //   cnyamount: 0,
      //   currency: 0
      // },
      HYFmoney: { // 海运费
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "CNY",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      // finaArapAirBeforeTHFDTO: { // 提货费
      //   amount: 0,
      //   cnyamount: 0,
      //   currency: 0
      // },
      tuoCheData: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "CNY",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: 0,
        piece: 1,
        minKilometer:'',
        maxKilometer:'',
      },
      uploadBgurl: [],
      cangkuitem: {}, // 入仓仓库信息
      PScangkuitem: {}, // 目的城市信息
      successDialogVisi: false,
      orderInfo: {}, // 订单提交成功后返回的信息
      customerNo: ''
    }
  },
  computed: {
    calculatePrice() { // 折合人民币
      //计算总费用
      let Totalmoney = 0; //总费用
      let PSFmoney = 0; //配送费
      let HYFmoney = 0; //海运费
      let THFmoney = 0; //提货费
      HYFmoney = this.HYFmoney.cnyamount ? +this.HYFmoney.cnyamount : 0;
      if (this.toDoorForm.isGetGoodsToDoor) {
        //如果有提货费
        THFmoney = this.tuoCheData.cnyamount ? +this.tuoCheData.cnyamount : 0;
      }
      Totalmoney = HYFmoney + PSFmoney + THFmoney;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.HYFmoney))); //海运费币种
      if (this.tuoCheData.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.tuoCheData))); //提货费费币种
      }
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
    productName() {
      let productName = ''
      if (this.goodsTypeOptions.length) {
        productName = this.goodsTypeOptions[0].productName
      }
      return productName
    }
  },
  watch: {
    'formPop.ssqnames'(newValue) {
      this.ssqnames = newValue
    },
    goodsInfoForm: {
      deep: true,
      handler(val) {
        console.log(val)
        val.GoodsList.forEach((item, index) => {
          if (item.l&&item.h&&item.w) {
            item.cbm = parseFloat(item.l*item.h*item.w/1000000).toFixed(4)
            item.totalcbm = (item.cbm*item.boxNum).toFixed(4)
            item.totalweight = (item.weight*item.boxNum).toFixed(4)
          } else {
            item.cbm = 0
          }
        })
        // this.getHTFcount()
        // this.getTimoney()
      }
    }
  },
  created() {
    if (localStorage.getItem("cangkuitem")) {
      this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"))
    }
    if (localStorage.getItem("PScangkuitem")) {
      this.PScangkuitem = JSON.parse(localStorage.getItem("PScangkuitem"))
    }
    if (sessionStorage.getItem('Authorization')) {
      this.entrustInfo.payType = JSON.parse(sessionStorage.getItem('Authorization')).settlementType
    }
    this.entrustInfo.inWarehouseId = this.cangkuitem.id
    this.entrustInfo.toWarehouseId = this.PScangkuitem.id
  },
  mounted() {
    // this.getTidata()
    // this.getSHdata()
    // this.getFadata()
    // this.getHTFcount()
    // this.getTimoney()
    // this.getPSFcount()
    // this.gettihuoLIst()
    this.getGoodsTypeList()
  },
  methods: {
    tradeInfoChange(val) {
      if(!val.length) {
        this.declareType = this.tradeInfoForm.declareType
        return
      }
      this.declareType = []
      this.declareType.push(val[1])
      this.tradeInfoForm.declareType = this.declareType
    },
    // 地址信息模块 start
    // 地址信息模块 end
    // 商品信息模块功能start
    goodTypechange(id) {
      this.goodsTypeOptions.forEach(item => {
        if(item.id === id) {
          this.addGoodsForm.GoodsList[0].goodstype = item.cnName
        }
      })
      this.getHTFcount()
    },
    GetgoodsType() {
      let that = this;
      this.axios.get(`/filedata/findItemCategoryAll?name=${this.page.name}`).then((res) => {
        if (res.data.code == "200") {
          console.log(res.data.datas);
          that.tabbar = res.data.datas;
        } else {
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    changeGoodstype() {
      const item = this.selectGoodslist[0]
      this.goodsTypeShow = false
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodsname = item.namec
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isBrand = item.hasBrand
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isHasBattery = item.hasBattery
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isPowderLiquid = item.hasLiquidPowder
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodsItemId = item.id
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodstype = item.goodstype
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodstypeid = item.goodstypeid
      this.page.name = ''
      this.getHTFcount()
    },
    handleSelectionChange(val) {
      this.selectGoodslist = val;
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getGoodsData()
    },
    getGoodsTypeList() {
      const productId = this.$route.query.productId
      this.axios.get(`/filedata/findDatGoodsSetInfoDTOList?id=${productId}`).then(res => {
        this.goodsTypeOptions = res.data.datas
      })
    },
    delGoods(index) {
      this.goodsInfoForm.GoodsList.splice(index, 1)
    },
    goodsInfoChange() {
      setTimeout(() => {
        this.getTimoney()
        this.getHTFcount()
      }, 0)
    },
    // 商品信息模块功能end
    changeTSssq(val) {
      this.tradeInfoForm.declareProvince = val[0]
      this.tradeInfoForm.declareCity = val[1]
      this.tradeInfoForm.declareArea = val[2]
    },
    // 运费计算
    getHTFcount() { // 获取运费
      let that = this;
      let itemDTOS = [];
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        let goodItem = {
          cbm: 0,
          weight: 0,
          goodsTypeId: "",
        };
        goodItem.cbm = item.totalcbm;
        goodItem.goodsTypeId = item.goodsTypeId;
        goodItem.weight = item.totalweight;
        itemDTOS.push(goodItem);
      });

      let params = {
        // feeCode: "QBHYF",
        pollandId: JSON.parse(localStorage.getItem("cangkuitem")).id, //起运地id,
        podlandId: JSON.parse(localStorage.getItem("PScangkuitem")).id, //目的地仓库
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        itemDTOS: itemDTOS,
      };
      this.axios.post(`/feeitem/getSeaFeeQuoteInfo`, params).then((res) => {
        console.log(res.data.data);
        if (res.data.code == "200") {
          that.HYFmoney.price = res.data.data.price;
          that.HYFmoney.currency = res.data.data.currency;
          that.HYFmoney.cnyprice = res.data.data.price;

          that.HYFmoney.amount = res.data.data.amount;
          that.HYFmoney.cnyamount = res.data.data.cnyamount;
          that.HYFmoney.goodsTypeFeeDTOS =
            res.data.data.goodsTypeFeeDTOS;
          that.goodsInfoForm.GoodsList.forEach((item, index) => {
            item.goodstype = res.data.data.itemDTOS[index].goodsTypeName;
            item.heavyUnitPrice =
              res.data.data.itemDTOS[index].heavyUnitPrice;
          });
        } else {
          that.HYFmoney.cnyamount = 0;
          that.HYFmoney.amount = 0;
          that.HYFmoney.price = "";
          that.HYFmoney.currency = "";
          that.HYFmoney.cnyprice = "";
          that.HYFmoney.goodsTypeFeeDTOS = [];
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    changeTi(val) {
      console.log(val);
      this.tuoCheData.checked = val
      // debugger
      if (val) {
        this.getTimoney();
      }
    },
    getTimoney() { // 获取提货费
      if (!this.toDoorForm.isGetGoodsToDoor) {
        return;
      }

      let weight = 0,
        cbm = 0;
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        weight += parseFloat(+item.totalweight);
        cbm += parseFloat(+item.totalcbm);
      });
      if (!(this.getGoodsDTO.getGoodsProvince&&this.getGoodsDTO.getGoodsCity)) {
        return
      }
      let params = {};
      params = {
        province: this.getGoodsDTO.getGoodsProvince, //省 name
        city: this.getGoodsDTO.getGoodsCity, //市 name
        area: this.getGoodsDTO.getGoodsArea, //区 name
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios.post(`/feeitem/getVASPriceForPickUp`, params).then((res) => {
        if (res.data.code == "200") {
          this.tuoCheData.checked = true
          this.tuoCheData.price = res.data.data.price; //价格
          this.tuoCheData.currency = res.data.data.currency; //币种
          this.tuoCheData.cnyprice = res.data.data.cnyprice; //--隐藏单价
          this.tuoCheData.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
          this.tuoCheData.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
          this.tuoCheData.amount = res.data.data.price;
          this.tuoCheData.minKilometer = res.data.data.minKilometer;
          this.tuoCheData.maxKilometer = res.data.data.maxKilometer;
        } else {
          // this.$message.error(res.data.message)
          this.tuoCheData.price = 0 //价格
          this.tuoCheData.currency = '' //币种
          this.tuoCheData.cnyprice = 0 //--隐藏单价
          this.tuoCheData.cnycurrency = '' //”CNY”--换算币种
          this.tuoCheData.cnyamount = 0 //”CNY”--换算币种
          this.tuoCheData.amount = 0
          this.tuoCheData.minKilometer = 0
          this.tuoCheData.maxKilometer = 0
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    changeSh(value) {
      this.sendFeeForAir.checked = value
      // this.sendFeeForAir.checked = !this.sendFeeForAir.checked;
      if (value) {
        this.getPSFcount();
      }
      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));
    },
    getPSFcount() {
      // if (!this.sendFeeForAir.tel) {
      //   return;
      // }
      let weight = 0,
        cbm = 0;
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      if (!(cbm > 0) || !this.goodsInfoForm.GoodsList[0].goodsname) {
        // this.$message.info('送货:请先添加商品')
        return;
      }
      // this.loadin = true;
      let params = {
        cbm: cbm,
        podlandId: this.sendFeeForAir.countryId, //目的国id
        podlandCityId: this.sendFeeForAir.cityId, //目的城市id
        podlandAreaId: this.sendFeeForAir.areaId, //目的仓库id
        toWarehouseId: JSON.parse(localStorage.getItem("PScangkuitem")).id,
      };
      this.axios.post(`/KYFee/getKYDeliveryFee`, params).then((res) => {
        // console.log(res);
        this.sendFeeForAir.price = res.data.data.price;
        this.sendFeeForAir.currency = res.data.data.currency; //币种
        this.sendFeeForAir.cnyprice = res.data.data.cnyprice; //单价
        this.sendFeeForAir.amount = res.data.data.price;
        this.sendFeeForAir.cnyamount = res.data.data.price;
        localStorage.setItem(
          "sendFeeForAir",
          JSON.stringify(this.sendFeeForAir)
        );
        // this.sendFeeForAir = JSON.parse(JSON.stringify(this.sendFeeForAir));
      })
      .catch((res) => {
        console.log(res);
      });
    },
    // 运费计算
    upload() {
      this.$refs.upload.$refs['upload-inner'].handleClick()
    },
    handleSuccess(res) {
      console.log(res);
      this.uploadBgurl.push(res.message)
    },
    handleError(err) {
      this.$message.error(this.$t('i18n_File_upload_failed'))
    },
    handleRemove(file) {
      this.uploadBgurl.forEach((item, index) => {
        if (item.indexOf(file.name) !== -1) {
          this.uploadBgurl.splice(index, 1)
        }
      })
    },
    handleExceed() {
      this.$message.warning(this.$t('i18n_Upload_up_to_one_file'))
    },
    fileUpload(fileObj) {
      let fd = new FormData()
      fd.append('file', fileObj.file)
      this.axios.post('/busKY/uploadAirJobsBGInfo', fd).then(res => {
        console.log(res.data)
        this.uploadBgurl.push(res.data.message)
        this.$message.success(this.$t('i18n_File_uploaded_successfully'))
      })
    },
    entrust() {
      let validArr = []
      this.$refs.entrustForm.validate((valid) => {
        validArr.push(valid)
      })
      if (this.toDoorForm.isGetGoodsToDoor) { // 上门取件才校验
        const value = this.$refs.address.submit()
        validArr.push(value)
      }
      // this.$refs.goodsForm.validate((valid) => {
      //   validArr.push(valid)
      // })
      if (!this.goodsInfoForm.GoodsList.length) {
        return this.$message.warning(this.$t('i18n_Please_add_products'))
      }
      if (this.tradeInfoForm.declareType[0] === 'T') {
        this.$refs.tradeForm.validate(valid => {
          validArr.push(valid)
        })
      }
      const flag = validArr.every(valid => valid)
      if (flag) {
        this.dialogTableVisible = true
      } else {
        this.scrollToFalse()
      }
    },
    scrollToFalse() { // 滚动到校验失败的位置
      this.$nextTick(() => {
        let isError = document.getElementsByClassName("is-error")
        isError[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        })
      })
    },
    submitOrder() { // 提交订单
      let params = {
        busLcljobsBeforeGoodsDTOList: this.goodsInfoForm.GoodsList,
        ...this.tradeInfoForm,
        delGoodsDTO: this.delGoodsDTO,
        getGoodsDTO: this.getGoodsDTO,
        ...this.toDoorForm,
        recGoodsDTO: this.recGoodsDTO,
        ...this.entrustInfo,
        customerId: this.Authorization.customerid,
        source: 'I',
        // finaArapAirBeforeAFFDTO: this.finaArapAirBeforeAFFDTO,
        // finaArapAirBeforeTHFDTO: this.finaArapAirBeforeTHFDTO,
        uploadBgurl: this.uploadBgurl.join(),
        finaArapLclBeforeQBHYFDTO: {
          amount: this.HYFmoney.amount,
          cnyamount: this.HYFmoney.cnyamount,
          currency: this.HYFmoney.currency
        },
        finaArapLclBeforeTHFDTO: {
          amount: this.tuoCheData.amount,
          cnyamount: this.tuoCheData.cnyamount,
          currency: this.tuoCheData.currency
        },
        productId: this.goodsTypeOptions[0].id,
        declareContacts: this.declarerDTO.declarerName,
        declareTelephone: this.declarerDTO.declarerTel,
        customerNo: this.customerNo
      }
      params.declareType = params.declareType[0]
      this.axios.post('/busLcljobsBefore/createLcljobsBefore', params).then(res => {
        if (res.data.code === 200) {
          this.orderInfo = res.data.data
          this.successDialogVisi = true
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err)
      })
      this.dialogTableVisible = false
    },
    pathBilltab() { // 查看订单详情
      this.$router.push({
        name: "OrderDetails",
        query: {
          nos: this.orderInfo.innos,
          state: '1'
        }
      })
    },
    nextSetbill() { // 继续下单
      this.successDialogVisi = false
      this.$router.push('/index/placeOrder/placeIndex')
    },
    labelDownload () {
      this.axios.get(`/busLcljobsBefore/downLclOrderLabel/${this.orderInfo.innos}`).then(res => {
        window.open(res.data.data)
      })
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    downLoadBill() { // 入仓单下载
      this.axios.get(`/arap/getInWarehouseLabel/${this.orderInfo.id}`,{
        responseType: 'arraybuffer'  /* 一定要加这个 不然文件内容显示不了 */
        })
      .then((res) => {
        let a = document.createElement('a');
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob);
        a.setAttribute("href",objectUrl);
        a.setAttribute("download", '入仓单.xls');
        a.click();
        // console.log(objectUrl);
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(a);// 释放标签
      })
    },
    addPls,
  }
}
</script>
<style lang="scss" scoped>
.center_wrap {
  display: flex;
  display: -webkit-flex;
  width: 1388px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 25px !important;
  margin: 15px 15px;
}
.wrap_l {
  float: left;
  width: 1100px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
  margin-right: 20px;
}
.tittype {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.weituo {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  .addMore {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}
}
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
/deep/ .el-form-item__label {
  color: rgb(153, 153, 153) !important;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑, "Heiti SC";
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.overText {
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.morentype {
  width: 60px;
  height: 20px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #5ab53c;
  background: #c7e4bd;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_R {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .ckttext {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9a9a9a;
  }
  .cangkutit {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #343434;
    float: left;
  }
}
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.Qdbtn {
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.btnstyle {
  width: 150px;
  height: 35px;
  background: #ffffff;
  border: 2px solid #dcdcdc;
  border-radius: 35px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.centerCoutn {
  width: 100%;
}
.countText {
  padding-top: 31px;
  width: 385px;
  margin: 0 auto;
  text-align: left;
  padding-left: 50px;
  box-sizing: border-box;
  p {
    margin-bottom: 10px;
  }
}
.btnWrap {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .LR_center {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    div {
      width: 135px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #5ab53c;
      border-radius: 5px;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5ab53c;
      cursor: pointer;
      &:nth-child(2) {
        background: #5ab53c;
        color: #ffffff;
      }
    }
  }
}
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
.SHInfo {
  padding: 15px;
  border-radius: 5px;
  background-color: #fff6e6;
  color: #f79c00;
  &:first-child {
    margin-top: 5px;
  }
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
.wrap_R {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 320px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 25px;
  margin-top: 15px;
  margin-left: 15px;
  padding: 20px;
  box-sizing: border-box;
  position: sticky;
  top: 15px;
}
.Item_Right {
  float: left;
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
  .tit {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #343434;
  }
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.fontString {
  font-weight: bold;
}
.el-table {
  /deep/ td {
    padding-top: 0;
    padding-bottom: 0;
  }
  /deep/ .el-form-item__content {
    .el-input,
    .el-select {
      .el-input__inner {
        text-align: center;
        padding: 0;
      }
    }
  }
  /deep/ .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.small{
  /deep/.el-form {
    .el-form-item {
      margin-top: 25px;
      margin-bottom: 25px;
    }
    .el-form-item__content {
      .el-form-item__error {
        padding-top: 1px
      }
    }
  }
}
.el-table {
  .el-button {
    margin: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/newBulkCargo.vue